angular.module('invoice')
    .controller('InvoiceBgtEditPositionController', function (data, toastr, $rootScope, $uibModalInstance, modals, Invoice, InvoiceService, InvoiceBgt) {
        this.InvoiceService = InvoiceService

        this.$onInit = () => {
            this.totalLeft = data.totalLeft
            this.totalNet = data.invoiceTotal
            this.entityId = data.entityId
            if(data.item) {
                this.item = angular.copy(data.item)
            }
            else {
                this.item = {
                    id: null,
                    amount: this.totalLeft,
                    currency: data.currency
                }
            }
            this.item.currency = data.currency || this.item.currency || 'PLN'
            this.onAmountChanged(this.item)
            this.currency = this.item.currency
        }

        this.onPercentageChanged = (c) => {
            this.item.amount = InvoiceService.multiply(this.percentage / 100, this.totalNet)
        }
        this.onAmountChanged = (c) => {
            this.percentage = InvoiceService.percentage(this.item.amount, this.totalNet) || 0
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = InvoiceBgt.update({entityId: this.entityId}, this.item).$promise
            } else {
                promise = InvoiceBgt.save({entityId: this.entityId}, this.item).$promise
            }
            return promise.then(result => {
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
